import Handsontable from "handsontable";
import {getDropCity, getPickupCity, mapInternalStatusToColor, orderPriorityColors} from "../ExcelFormattedOrders/Settings";
import {Constants} from "../../Constants/Constant";
import {isChargesEditable} from "./Settings";
let roleId = localStorage.roleId;

export function orderNumberRenderer(instance, td, row, col, prop, value, cellProperties, self, array) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  let pRow = instance.toPhysicalRow(row);                                   //When accessing original array
  let clientInvoice = self[array][pRow];
  let priority = clientInvoice?.Order.priority;

  td.innerHTML = '<span>'+value.substring(0, 3)+'</span>' +'<span>'+value.substring(3, 9)+'</span><br>' +
    '<span>'+value.substring(9, 11)+'</span>'+'<span>' + value.substring(11, value.length) + '</span>'

  if(orderPriorityColors[priority]){
    // td.style.color = orderPriorityColors[priority]
    td.children[0].style.color = orderPriorityColors[priority][0]
    td.children[1].style.color = orderPriorityColors[priority][1]
    td.children[3].style.color = orderPriorityColors[priority][1]
    td.children[4].style.color = orderPriorityColors[priority][0]
  }
  td.classList.add('underline-txt')
  td.onclick = () => {
    self.editOrder(clientInvoice.Order)
  }
}

export function statusRenderer(instance, td, row, col, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  let internalStatus = instance.getDataAtRowProp(row, 'internalStatus')                               //prop name 'internalStatus'
  td.innerHTML = internalStatus
  // td.style.background = mapInternalStatusToColor[value][0]
  td.style.setProperty("background", mapInternalStatusToColor[value][0], "important");
  if (mapInternalStatusToColor[value][1]) {
    // td.style.color = mapInternalStatusToColor[value][1]
    td.style.setProperty("color", mapInternalStatusToColor[value][1], "important");
  }
}

/* Define 'Returned Invoices' & 'PendingForCancel Invoices' row color */
export function orderDetailsRenderer(instance, td, row, col, prop, value, cellProperties, self, array) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  let pRow = instance.toPhysicalRow(row);                                   //When accessing original array
  let clientInvoice = self[array][pRow];
  let type = clientInvoice?.Order.materials.type;

  td.innerHTML = '<span style="color: gray">' + type + '</span>'+ '<br>' + value;

  if(clientInvoice?.isReturned && clientInvoice?.statusId === Constants.ClientInvoiceStatus.New) td.parentElement.classList.add('returned-invoice');
  else td.parentElement.classList.remove('returned-invoice');

  if(clientInvoice?.statusId === Constants.ClientInvoiceStatus.PendingForCancel) td.parentElement.classList.add('pending-cancel-invoice');
  else td.parentElement.classList.remove('pending-cancel-invoice');
}

export function orderCityChargesRenderer(instance, td, row, col, prop, value, cellProperties, self, array) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  let pRow = instance.toPhysicalRow(row);                                   //When accessing original array
  let clientInvoice = self[array][pRow];
  let hasQuery = clientInvoice?.orderCharges.nodes.some(n => n.query);

  if(hasQuery) td.classList.add('include-query');
  else if(clientInvoice?.orderCharges.nodes.length) td.classList.add('no-query');
  else {td.innerHTML = 'Add'; td.title = 'Add Order City Charges'; td.classList.add('add-link');}

  let city = clientInvoice?.Order.clientobject.address[0].city;
  let isEditable = isChargesEditable(roleId, undefined, city);
  if(isEditable) {
    td.classList.add('charge-amount');
    td.onclick = () => { self.openChargesForm(Constants.PointTypes.OrderCity, clientInvoice.id); }
  }else td.onclick = null;
}

export function pickupCityChargesRenderer(instance, td, row, col, prop, value, cellProperties, self, array) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  let pRow = instance.toPhysicalRow(row);                                   //When accessing original array
  let clientInvoice = self[array][pRow];
  let hasQuery = clientInvoice?.pickupCharges.nodes.some(n => n.query);
  if(hasQuery) td.classList.add('include-query');
  else if(clientInvoice?.pickupCharges.nodes.length) td.classList.add('no-query');
  else {td.innerHTML = 'Add'; td.title = 'Add Pickup City Charges'; td.classList.add('add-link');}

  let city = getPickupCity(clientInvoice?.Order);
  let isEditable = isChargesEditable(roleId, undefined, city);
  if(isEditable) {
    td.classList.add('charge-amount');
    td.onclick = () => { self.openChargesForm(Constants.PointTypes.PickupCity, clientInvoice.id); }
  }else td.onclick = null;
}

export function dropCityChargesRenderer(instance, td, row, col, prop, value, cellProperties, self, array) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  let pRow = instance.toPhysicalRow(row);                                   //When accessing original array
  let clientInvoice = self[array][pRow];
  let hasQuery = clientInvoice?.dropCharges.nodes.some(n => n.query);
  if(hasQuery) td.classList.add('include-query');
  else if(clientInvoice?.dropCharges.nodes.length) td.classList.add('no-query');
  else {td.innerHTML = 'Add'; td.title = 'Add Drop City Charges'; td.classList.add('add-link');}

  let city = getDropCity(clientInvoice?.Order);
  let isEditable = isChargesEditable(roleId, undefined, city);
  if(isEditable) {
    td.classList.add('charge-amount');
    td.onclick = () => { self.openChargesForm(Constants.PointTypes.DropCity, clientInvoice.id); }
  }else td.onclick = null;
}

export function billingFreightRenderer(instance, td, row, col, prop, value, cellProperties, self, array) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  if(value === null) td.innerHTML = 'Add';
}

export function totalAmountRenderer(instance, td, row, col, prop, value, cellProperties, self, array)  {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  let pRow = instance.toPhysicalRow(row);                                   //When accessing original array
  let clientInvoice = self[array][pRow];

  let hasQuery = clientInvoice?.orderCharges.nodes.some(n => n.query) || clientInvoice?.pickupCharges.nodes.some(n => n.query) || clientInvoice?.dropCharges.nodes.some(n => n.query);
  if(hasQuery) td.classList.add('include-query');
  else if(clientInvoice?.orderCharges.nodes.length || clientInvoice?.pickupCharges.nodes.length || clientInvoice?.dropCharges.nodes.length) td.classList.add('no-query');
}

export function createClientActionRenderer(instance, td, row, col, prop, value, cellProperties, self, array) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  let pRow = instance.toPhysicalRow(row);                                   //When accessing original array
  let clientInvoice = self[array][pRow];

  td.innerHTML = '<span class="action-btn green-txt" title="Create Invoice"> Create </span> / <span class="action-btn red-txt" title="Cancel Invoice"> Cancel </span>'
  td.children[0].onclick = () => { self.openActionPopup('pendingApprovalActionDialog', clientInvoice.id) };
  td.children[1].onclick = () => { self.openActionPopup('pendingCancelActionDialog', clientInvoice.id) };
}

export function authorizeClientActionRenderer(instance, td, row, col, prop, value, cellProperties, self, array) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  let pRow = instance.toPhysicalRow(row);                                   //When accessing original array
  let clientInvoice = self[array][pRow];

  td.innerHTML = '<span class="action-btn green-txt" title="Approve Invoice"> Approve </span> / <span class="action-btn red-txt" title="Reject Invoice"> Reject </span>'
  td.children[0].onclick = () => { self.openActionPopup('acceptActionDialog', clientInvoice.id) };
  td.children[1].onclick = () => { self.openActionPopup('declineActionDialog', clientInvoice.id) };
}

export function canceledClientActionRenderer(instance, td, row, col, prop, value, cellProperties, self, array) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  let pRow = instance.toPhysicalRow(row);                                   //When accessing original array
  let clientInvoice = self[array][pRow];

  td.innerHTML = '<span class="action-btn" title="Create Invoice"> Create Invoice </span>'
  td.children[0].onclick = () => { self.openActionPopup('declineActionDialog', clientInvoice.id) };
}
